__turbopack_context__.v({
  "active": "style-module-scss-module__Zg0hrq__active",
  "description": "style-module-scss-module__Zg0hrq__description",
  "error": "style-module-scss-module__Zg0hrq__error",
  "fadeScrollerInner": "style-module-scss-module__Zg0hrq__fadeScrollerInner",
  "field": "style-module-scss-module__Zg0hrq__field",
  "fieldsWrap": "style-module-scss-module__Zg0hrq__fieldsWrap",
  "footerBottom": "style-module-scss-module__Zg0hrq__footerBottom",
  "footerDescription": "style-module-scss-module__Zg0hrq__footerDescription",
  "form": "style-module-scss-module__Zg0hrq__form",
  "fullWidthField": "style-module-scss-module__Zg0hrq__fullWidthField",
  "heading": "style-module-scss-module__Zg0hrq__heading",
  "hidden": "style-module-scss-module__Zg0hrq__hidden",
  "radioWrap": "style-module-scss-module__Zg0hrq__radioWrap",
  "scrollOuter": "style-module-scss-module__Zg0hrq__scrollOuter",
  "submit": "style-module-scss-module__Zg0hrq__submit",
  "title": "style-module-scss-module__Zg0hrq__title",
});
